import { Outlet } from 'react-router-dom';
import { SectionNav, type Section } from '../components/SectionNav';

/**
 * The three things a publisher does under Email lists, side by side.
 *
 * Quizee captures signups and hands them on to whatever a publisher already sends with; it does
 * not send anything itself. Subscribers is the register of who has agreed to what, Lists is where
 * a masthead tells its briefings apart from each other so a reader who signs up twice from two
 * different articles is not folded into one undifferentiated subscription, and Mailchimp is the
 * handoff itself for a publisher whose "whatever we already send with" is Mailchimp. None of the
 * three composes or sends a message on quizee's own account: the last one connects a key and
 * picks an audience, and Mailchimp does the sending from there.
 */
const SECTIONS: readonly Section[] = [
  { to: '/newsletters', label: 'Subscribers', end: true },
  { to: '/newsletters/lists', label: 'Lists' },
  { to: '/newsletters/mailchimp', label: 'Mailchimp' },
];

export function EmailLists() {
  return (
    <>
      <SectionNav label="Email list sections" sections={SECTIONS} orientation="horizontal" />
      <Outlet />
    </>
  );
}
